import { createRouter, createWebHistory } from 'vue-router';
import { resolveRuntimeBase } from './runtimeBase';

// 路由配置 - 使用动态导入实现代码分割
const routes = [
  {
    path: '/',
    name: 'start-gate',
    alias: ['/index.html'],
    component: () => import('../modules/onboarding/views/StartGateView.vue'),
  },
  {
    path: '/welcome',
    name: 'welcome',
    component: () => import('../modules/onboarding/views/WelcomeView.vue'),
  },
  {
    path: '/world-intro',
    name: 'world-intro',
    component: () => import('../modules/onboarding/views/WorldIntroView.vue'),
  },
  {
    path: '/story-background',
    name: 'story-background',
    component: () => import('../modules/onboarding/views/StoryBackgroundView.vue'),
  },
  {
    // 旧路由兼容重定向
    path: '/story-intro',
    redirect: '/world-intro',
  },
  {
    path: '/character-creation',
    name: 'character-creation',
    component: () => import('../modules/character/views/creation/CharacterCreationView.vue'),
  },
  {
    path: '/main',
    name: 'main',
    component: () => import('../views/route-shells/Main/MainRouteEntry.vue'),
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/',
  },
];

const appBase = resolveRuntimeBase(import.meta.url);

// 创建路由实例
export const router = createRouter({
  history: createWebHistory(appBase),
  routes,
});
